/**
 * Stati possibili della colonna `Chats.ai_status`.
 * Usato da Master AI, Lore e Story-setting per comunicare alla UI
 * in quale fase della pipeline si trova l'elaborazione.
 */
export type ChatAiStatus =
  | 'recalling' // richiamo contesto / grafo
  | 'coherence' // controllo coerenza messaggi giocatore
  | 'drafting' // generazione risposta
  | 'finalizing' // salvataggio messaggio / setting_brief + effetti
  | 'worldbuilding' // aggiornamento memoria Neo4j
  | null;

/** Stati che indicano che la chat AI è occupata e non accetta nuove invocazioni. */
export const BUSY_CHAT_AI_STATUSES: ChatAiStatus[] = [
  'recalling',
  'coherence',
  'drafting',
  'finalizing',
  'worldbuilding',
];

/** Ritorna true se lo stato indica che Master/Lore/Story-setting è ancora al lavoro. */
export function isChatAiBusy(
  status: string | null,
): status is Exclude<ChatAiStatus, null> {
  return status !== null && BUSY_CHAT_AI_STATUSES.includes(status as ChatAiStatus);
}

/** Stati in cui il footer di chat deve essere nascosto. */
export const CHAT_AI_STATUSES_HIDING_FOOTER: ChatAiStatus[] = [
  'recalling',
  'coherence',
  'drafting',
  'finalizing',
];

/** Ritorna true se il footer deve essere nascosto mentre l'AI è occupata. */
export function shouldChatAiStatusHideFooter(
  status: ChatAiStatus,
): boolean {
  return CHAT_AI_STATUSES_HIDING_FOOTER.includes(status);
}

/** Stati in cui l'icona dell'overlay cambia in globe (worldbuilding). */
export const CHAT_AI_STATUS_WORLD_BUILDING: ChatAiStatus = 'worldbuilding';

/** Normalizza un valore grezzo dal DB al type ChatAiStatus. */
export function normalizeChatAiStatus(
  status: string | null,
): ChatAiStatus {
  if (status === null) return null;
  if (BUSY_CHAT_AI_STATUSES.includes(status as ChatAiStatus)) {
    return status as Exclude<ChatAiStatus, null>;
  }
  return null;
}
